import { createFileRoute, Link } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/no-access')({
  component: NoAccessPage,
});

function NoAccessPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-2xl font-semibold">Access denied</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        Your account does not have permission to view this page. Contact an
        administrator if you believe this is a mistake.
      </p>
      <Button variant="outline" render={<Link to="/">Back to home</Link>} />
    </div>
  );
}
